import axios from 'axios';
import { v4 } from 'uuid';
import Cookies from 'js-cookie';

import { FunctionProps, UnwrapPromise } from '@utils/types';
import { ServiceRegistry, Service } from '@api/service-registry';
import { normalizeApiErrors } from '@utils/api/customErrorHandler';

import { createUUID } from './core/request';

export const getRequestHeaders = (): Record<string, string> => {
  const token =
    typeof window !== 'undefined'
      ? Cookies.get('token') ||
        localStorage.getItem('token') ||
        createUUID('token', false, false)
      : createUUID('token', false, false);
  const basketId =
    typeof window !== 'undefined' && localStorage.getItem('basketId');
  const cid = v4();

  return {
    token,
    authorization: token,
    correlationId: cid,
    ...(basketId && { basketId }),
  };
};

export async function callService<
  S extends Service,
  M extends FunctionProps<ServiceRegistry[S]> = FunctionProps<
    ServiceRegistry[S]
  >
>(
  Service: S,
  method: M,
  ...args: ServiceRegistry[S][M] extends (...args: infer Args) => unknown
    ? Args
    : never
) {
  const hostname =
    typeof window !== 'undefined' ? '' : process.env.NEXT_PUBLIC_HOST;

  const path = `${hostname}/api/services/${Service}/${method}`;
  const headers = getRequestHeaders();

  let result: UnwrapPromise<ServiceRegistry[S][M]>;
  try {
    const { data } = await axios.post<UnwrapPromise<ServiceRegistry[S][M]>>(
      path,
      { args },
      { headers }
    );
    result = data;
  } catch (e) {
    result = (e as any).response.data as UnwrapPromise<ServiceRegistry[S][M]>;
  }
  return normalizeApiErrors(result);
}
